import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { fetchStatements } from '../../store/statementsSlice';
import StatementsTable from './StatementsTable'
import StatementDetails from './StatementDetails';

const Statements = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [statementToShow, setStatementToShow] = useState(null);
  const { viewStatements } = useSelector((state) => state.user.user);
  const { portfolioFinancialData, isLoadingFinancial: sitesLoading, error: siteError } = useSelector((state) => state.sites);
  const { statements, isLoading: statementsLoading, error: statementsError } = useSelector((state) => state.statements);
  const siteIds = portfolioFinancialData?.sites.map(s => s.id);
  const siteNames = portfolioFinancialData?.sites.reduce((acc, curr) => {
    acc[curr.id] = curr.siteName;
    return acc;
  }, {});

  const isLoading = statementsLoading || sitesLoading;
  const isError = statementsError || siteError;
  const isData = portfolioFinancialData && statements

  useEffect(() => {
    if (!viewStatements) {
      navigate('/')
    }
  }, [viewStatements, navigate])

  useEffect(() => {
    if (portfolioFinancialData) {
      dispatch(fetchStatements(siteIds));
    }
    
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [portfolioFinancialData]);

  const handleViewStatementClick  = (statement) => {
    setStatementToShow(statement);
  }

  if (!!statementToShow) {
    return (
      <div className="pl-[64px] pt-[24px] h-full">
        <StatementDetails 
          statement={statementToShow} 
          handleViewStatementClick={handleViewStatementClick}
          siteNames={siteNames}
        />
      </div>
    )
  }

  return (
    <div className="pl-[64px] pt-[24px] h-full">
    <div className="bg-white rounded-[12px] py-[20px] px-[16px]">
      <h2 className="text-[22px] font-medium ">Statements</h2>
    </div>
    <StatementsTable 
      statements={statements} 
      siteNames={siteNames} 
      isData={isData} 
      isLoading={isLoading} 
      isError={isError}
      handleViewStatementClick={handleViewStatementClick}
    />
  </div>
  );
};

export default Statements;